import CalendarModal from "./calendarModal";
import {Modal} from "antd";
import {useState} from "react";

const CalendarModalParent = ({visible, onCancel, onData}) => {

    const [destroy, setDestroy] = useState(false)
    return (
        <Modal visible={visible}
               width={990}
               onCancel={() => {
                   setDestroy(true)
               }}
               title={"Tùy chọn thời gian báo cáo "}
               bodyStyle={{
                   minHeight: 100,
                   maxHeight: 600,
                   height: 510,
                   overflowY: "hidden",
               }}
               className="modalStyle modalStyleParent "
               destroyOnClose={true}
               footer={null}>
            <CalendarModal onCancel={onCancel}
                           destroy={destroy}
                           onDestroy={() => setDestroy(false)}
                           onData={onData}/>
        </Modal>
    )
}
export default CalendarModalParent
